export default "/images/staffing_and_professional_development_sm.jpg?46252151ee05c16f8cf35131c4989b54";